const LOAD_DATA_JOB_POSTING_TYPE           = 'LOAD_DATA_JOB_POSTING_TYPE'
const LOAD_DATA_JOB_POSTING_TYPE_SUCCESS   = 'LOAD_DATA_JOB_POSTING_TYPE_SUCCESS'
const LOAD_DATA_JOB_POSTING_TYPE_FAILED    = 'LOAD_DATA_JOB_POSTING_TYPE_FAILED'
const UNMOUNT_DATA_JOB_POSTING_TYPE        = 'UNMOUNT_DATA_JOB_POSTING_TYPE'

const initialState = {
  loading: true,
  data: null,
  message: null,
  pagination: {
    page: 1,
    total: 0,
    perpage: 10
  }
}

const jobPostingTypeReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DATA_JOB_POSTING_TYPE:
      return {
        ...state,
        loading: true,
        data: null,
        pagination: {
          page: 1,
          total: 0,
          perpage: 10
        }
      }
    case LOAD_DATA_JOB_POSTING_TYPE_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
        pagination: {
          total: action.payload.pagination.total,
          page: action.payload.pagination.page,
          perpage: action.payload.pagination.perpage
        }
      }
    case LOAD_DATA_JOB_POSTING_TYPE_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
        pagination: {
          page: 1,
          total: 0,
          perpage: 10
        }
      }
    case UNMOUNT_DATA_JOB_POSTING_TYPE:
      return { 
        ...state, 
        loading: true,
        data: null,
        pagination: {
          page: 1,
          total: 0,
          perpage: 10
        }
      }
    default:
      return state
  }
}

export default jobPostingTypeReducer;